import React from 'react';
import LogosEmpresaAseguradora from '../../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import { SiniestroProvider } from '../../../context/siniestro-context';
import Stepper from './steps/Stepper';

function PeritajeForm(props) {
  return (
    <>
      <LogosEmpresaAseguradora />
      <ResponsiveContainer size="large">
        <SiniestroProvider>
          <Stepper props={props} />
        </SiniestroProvider>
      </ResponsiveContainer>
    </>
  );
}

export default PeritajeForm;
